export default {
  GET_COUNTRIES_QUERY_SERVICE: Symbol.for('GET_COUNTRIES_QUERY_SERVICE'),
  COUNTRY_REPOSITORY: Symbol.for('COUNTRY_REPOSITORY'),
  ONBOARDING_CATALOG_COUNTRY_STATE_MANAGER: Symbol.for('ONBOARDING_CATALOG_COUNTRY_STATE_MANAGER'),
};
